export default __webpack_public_path__ + "static/media/page-content-bg.47169eb3.svg";